import { Line, LineChart } from 'recharts';

import { cn } from '../../lib/utils';

interface SparklineProps {
  data: Array<{ date: string; value: number }>;
  label: string;
  className?: string;
}

export function Sparkline({ className, data, label }: SparklineProps) {
  const first = data[0]?.value ?? 0;
  const last = data.at(-1)?.value ?? first;
  const stroke = last >= first ? '#10B981' : '#EF4444';

  return (
    <div className={cn('h-8 min-w-24', className)} role="img" aria-label={label}>
      <LineChart
        className="h-full w-full"
        data={data}
        height={32}
        margin={{ top: 3, right: 1, bottom: 3, left: 1 }}
        width={120}
      >
        <Line
          type="monotone"
          dataKey="referenceValue"
          stroke="#6B7280"
          strokeDasharray="3 3"
          strokeWidth={1}
          dot={false}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="value"
          stroke={stroke}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </div>
  );
}
